export const sizing = {
  avatar: {
    sm: 40,
    md: 80,
    lg: 120,
  },
  icon: {
    xs: 16,
    sm: 20,
    md: 24,
    lg: 32,
    xl: 60,
  },
  button: {
    sm: 24,
    md: 32,
    lg: 40,
  },
  scrollbar: 8,
} as const;
